import React, { Component, Fragment } from 'react'
import { AppFormLayoutContext } from './AppFormLayout'
import { AppFormItem as AppFormItemProps } from 'api/index'
import { AppLabel, AppInput, AppDate, AppRadio, AppSelect, AppTextArea } from 'components/AppFormItem'
import { AppFormContext } from './AppFormData'
import { AppInputProps } from 'components/AppFormItem/AppInput'
import { AppRadioProps } from 'components/AppFormItem/AppRadio'
import { AppSelectProps } from 'components/AppFormItem/AppSelect'
interface FormItemProps {
	label: string
	field: string
	req?: boolean
	value?: string | number
	index?: number
	text?: string
	dataType?: 'string' | 'number'
	colSpan?: number
	labelHidden?: boolean
	placeholder?: string
	disabled?: boolean
	textField?: string
	format?: string
	width?: number | string
	itemWidth?: number
	maxNumber?: number
	minNumber?: number
	maxLength?: number
	readonly?: boolean
	tips?: string
	URL?: string
	parameter?: string
	render?: (data: any) => JSX.Element | string
}
interface FormItem extends FormItemProps {
	type?: 'SearchInput' | 'Input' | 'Date' | 'Label' | 'Textarea' | 'Table'
}

export default class AppFormItem extends Component<AppFormItemProps> {
	handleTable = () => {
		return <React.Fragment />
	}
	renderhighlight = (field: string, context: AppFormLayoutContext) => {
		return (
			<React.Fragment>
				{context.formData[field] && context.formData[field].highlight ? (
					<div className="app-highlight-item" />
				) : null}
			</React.Fragment>
		)
	}

	handlerender = (type: any, context: AppFormContext) => {
		const { field } = this.props
		switch (type) {
			// case 'SearchInput':
			// 	console.log(context.formData[field])
			// 	return <AppFormItemSearchInput {...context.formData[field]} />
			case 'Input':
				// console.log('context', context, context.formData)
				return (
					<AppInput
						{...{ ...(this.props as AppInputProps), value: context.formData[field] }}
						onChange={(value: any) => {
							context.onChange(this.props, value)
						}}
					/>
				)
			case 'Date':
				return (
					<AppDate
						{...context.formData[field]}
						onChange={(value, text) => {
							context.onChange(this.props, text)
						}}
					/>
				)
			case 'Label':
				return <AppLabel {...context.formData[field]} />
			case 'Radio':
				return (
					<AppRadio
						{...{ ...(this.props as AppRadioProps), value: context.formData[field] }}
						onChange={(value: any, label: string) => {
							context.onChange(this.props, value, label)
						}}
					/>
				)
			case 'Select':
				return (
					<AppSelect
						{...{ ...(this.props as AppSelectProps), value: context.formData[field] }}
						onChange={(value: any, label: string) => {
							context.onChange(this.props, value, label)
						}}
					/>
				)
			case 'Textarea':
				return (
					<AppTextArea
						{...context.formData[field]}
						onChange={(value: any, text: any) => {
							context.onChange(this.props, value)
						}}
					/>
				)
			case 'Table':
				return this.handleTable()
			default:
				return <React.Fragment />
		}
	}

	render() {
		return (
			<AppFormContext.Consumer>
				{context => {
					return <Fragment>{this.handlerender(this.props.type, context)}</Fragment>
				}}
			</AppFormContext.Consumer>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormItem.tsx